(function (angular, _) {
    const MyHippoProducerServices = angular.module('MyHippoProducer.Services');
    MyHippoProducerServices.factory('StradaService', function ($log, $window, $injector, AnalyticsService) {
        let isStarted = false;
        let stradaInitTimeout = null;

        const getEventProperties = function (userData) {
            const organizationName = _.get(userData, 'main_organization.name');
            const organizationId = _.get(userData, 'organization_id');
            const rootOrganizationId = _.get(userData, 'main_organization_id');
            const producerId = _.get(userData, 'data.external_producer_id');

            return {
                organization_name: organizationName,
                organization_id: organizationId,
                root_organization_id: rootOrganizationId,
                producer_id: producerId,
            };
        };

        const trackStradaToggle = function (userData, isOpen) {
            AnalyticsService.trackEvent('strada_chat_toggled', Object.assign(getEventProperties(userData), {
                is_open: isOpen,
            }));
        };

        const trackStradaButtonSeen = function (userData) {
            AnalyticsService.trackEvent('strada_chat_button_seen', getEventProperties(userData));
        };

        const startStradaChat = function (userData, isLoggedIn) {
            const { STRADA_ORGANIZATION_ID, STRADA_AGENT_ID } = $window.appConfig;

            if (!STRADA_ORGANIZATION_ID || !STRADA_AGENT_ID) {
                return;
            }

            if (!$window.stradaChat) {
                if (stradaInitTimeout) {
                    clearTimeout(stradaInitTimeout);
                }
                stradaInitTimeout = setTimeout(function() {
                    startStradaChat(userData, isLoggedIn);
                }, 100);
                return;
            }

            const stradaNotLoggedUserConfig = {
                agentId: STRADA_AGENT_ID,
                hideButton: true,
                organizationId: STRADA_ORGANIZATION_ID
            };

            if (!isLoggedIn) {
                $window.stradaChat.start(stradaNotLoggedUserConfig);
                isStarted = true;
                return;
            }

            const email = _.get(userData, 'email');
            const userName = _.get(userData, 'data.name', '');
            const agentId = _.get(userData, 'data.external_producer_id');
            const [firstName = '', lastName = ''] = userName.trim().split(' ');
            const userId = _.get(userData, 'id');

            const agentVariables = {
                email,
                first_name: firstName,
                last_name: lastName,
                agent_id: agentId,
            };

            const stradaLoggedUserConfig = {
                agentId: STRADA_AGENT_ID,
                organizationId: STRADA_ORGANIZATION_ID,
                hideButton: false,
                agentVariables: agentVariables,
                secureMetadata: { internalUserId: userId },
                stradaReadyCallback: function() {
                    trackStradaButtonSeen(userData);
                },
                toggleCallback: function(isOpen) {
                    trackStradaToggle(userData, isOpen);
                }
            };

            $window.stradaChat.start(stradaLoggedUserConfig);
            isStarted = true;
        };

        const StradaService = {
            initialize: function (userData, isLoggedIn) {
                if (isStarted) {
                    return;
                }

                const { FLAGSHIP_STRADA_CAMPAIGN_ID } = $window.appConfig;

                if (!FLAGSHIP_STRADA_CAMPAIGN_ID) {
                    return;
                }

                const FlagshipService = $injector.get('FlagshipService');

                FlagshipService.getCampaignData({ campaignID: FLAGSHIP_STRADA_CAMPAIGN_ID })
                    .then((res) => {
                        const enableStradaChat = _.get(
                            res,
                            'data.variation.modifications.value.enableStradaChat',
                            false
                        );

                        if (enableStradaChat) {
                            startStradaChat(userData, isLoggedIn);
                        }
                    });
            },
        };

        return StradaService;
    });
})(window.angular, window._);
